<script>
    import * as api    from '../../shared/api.js'
    import {parseDate} from '../../shared/utils.js'
    
    export let item
    export let status
    export let active

    let loading  = false
    let response = null
    let data     = []
    let notFound = false
    let error    = false

    function valueGiven(item, field) {
        if(!response) {
            return ''
        } else {
            return item["f"+field.id] || '∅'
        }
    }

    function dateGiven(response, field) {
        return response ? parseDate(response.at) : ''
    }

    function keys() {
        return item.keys.filter(i => i.place.id === status.place.id)
    }

    function loadResponse(active) {
        const assign = json => {
            response = json
            data     = response.data
        }
        if(active) {
            loading = true
            api 
                .get(`/inquiry/${item.inquiry.protocol}/source/${status.place.identifier}/response`)
                .then(r => {
                    loading = false
                    switch(r.status) {
                        case 200 : r.json().then(assign) ; return
                        case 404 : notFound = true       ; return 
                        default  : error    = true       ; return 
                    }                    
                })
                .catch(e => {
                    error = e
                })
        } else {
            response = null
            data     = []
            error    = false
            notFound = false
        }
    }

    function partyType(response) {
        if(response) {
            switch(response.partyType) {
                case "PIN"    : return "PIN"
                case "SYSTEM" : return "Sistema"
                case "USER"   : return "Usuário"
                default       : return "Impossível identificar"
            }
        }
    }

    function party(response) {
        return response && response.party 
    }

    $: loadResponse(active) 

</script>
<div class="ui segment" class:loading>
    <h4 class="ui header">Chaves</h4>
    <div class="ui list">
        {#each keys() as key}
        <div class="item">
            <div class="header">{key.field.name || key.field.definition}</div>
            {key.value}
        </div>
        {/each}
    </div>

    <h4 class="ui header">Resposta</h4>
    <div class="ui list">
        <div class="item">
            <div class="header">Tipo</div>
            {partyType(response) || ''}
        </div>
        <div class="item">
            <div class="header">Autor</div>
            {party(response) || ''}
        </div>

    </div>

    <h4 class="ui header">Dados Encontrados</h4>
    {#each data as item}
        <table class="ui padded large table">
            <thead>
                <tr>
                    <th class="one wide">Chave</th>
                    <th class="one wide">Obrigatório</th>
                    <th>Nome</th>
                    <th>Definição</th>
                    <th>Data</th>
                    <th>Valor</th>
                </tr>
            </thead>
            <tbody>
                {#each status.place.fields as field (field.definition)}
                    <tr>
                        <td>
                            <i  class="circle icon" 
                                class:faded={!field.key}
                                class:outline={!field.key} 
                                class:green={field.key}>
                            </i>            
                        </td>
                        <td>
                            <i  class="circle icon" 
                                class:faded={!field.required}
                                class:outline={!field.required} 
                                class:green={field.required}>
                            </i>
                        </td>
                        <td>{field.name || ''}</td>
                        <td>{field.definition}</td>
                        <td>
                            {#if notFound}
                                <span class="ui label">Indisponível</span>
                            {:else}
                                {dateGiven(response, field)}
                            {/if}
                        </td>
                        <td>
                            {#if notFound}
                                <span class="ui label">Indisponível</span>
                            {:else}
                                {valueGiven(item, field)}
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    {/each}
</div>


